/** Display formatting for table cells. Presentation only — never mutates stored values. */

/** 4407 -> "4,407.00". Falsy-safe so a missing field renders "0.00", not "NaN". */
export const money = (value?: number | string | null): string => {
    const n = Number(value ?? 0);
    if (!isFinite(n)) return '0.00';
    return n.toLocaleString('en-MY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

/** 4407 -> "4,407". For counts, where decimals would be noise. */
export const count = (value?: number | string | null): string => {
    const n = Number(value ?? 0);
    if (!isFinite(n)) return '0';
    return n.toLocaleString('en-MY');
};
